import moment from "moment";

/**
 * Preprocess table entries for rendering:
 *    currently it does one thing:
 *      in the first column, show the time part only if date is today
 * @param {Array} entries latest approvals | latest leads | latest contracts
 * @param {String} dateAttribName
 * @return {Array} table entries with date attribute only having the time part if date is today
 *                                   otherwise, keep date attribute as date-time
 */
export function preprocessTableEntries(entries, dateAttribName) {
  const now = moment();
  const acceptedDateFormats = ['YYYY-MM-DDTHH:mm:ss.SSSSSSZ', 'MM/DD/YYYY hh:mm A'];

  const processedEntries = entries.map((entry) => {
    const date = moment(entry[dateAttribName], acceptedDateFormats);
    let formattedDate;
    if (now.isSame(date, 'day')) {
      formattedDate = date.format('hh:mm A');
    } else {
      formattedDate = date.format('MM/DD/YYYY hh:mm A');
    }
    return {...entry, [dateAttribName]: formattedDate};
  });

  return processedEntries;
}